import { DailyLogOperationInstance } from '../../models/projects/operation.models';
import { HierarchyCollision } from '../../models/projects/validation.models';
import { PtLuxonDate } from '../../models/projects/date.models';
import { DateTime } from 'luxon';

export class Entry {
  id: number;
  content: string;
  start: DateTime;
  startToShow: string;
  end: DateTime;
  endToShow: string;
  style?: string;
  group: string;
  isContractual: boolean;
  contractualPriority: number;
}

export class HierarchyTableGroup {
  resolvedEntries: Entry[][];
  collision: HierarchyCollisionSection = new HierarchyCollisionSection();
}

export class TimelineEntry {
  start: DateTime;
  end: DateTime;
  content: string;
}

export class GapOverlapValidationRow {
  operationClassification: string;
  operationName: string;
  startTimeShow: string;
  endTimeShow: string;
  error: string;
  instanceId: number;
  date: DateTime; // start date
  endDate: DateTime;
}

export class OpenEndedValidationRow {
  operationClassification: string;
  operationName: string;
  startTimeShow: string;
  warning: string;
  instanceId: number;
}

export class HierarchyCollisionSection {
  collision: HierarchyCollision;
  instances: DailyLogOperationInstance[] = [];
  minTime: PtLuxonDate;
  maxTime: PtLuxonDate;
  title: string;
  id: number;
}



// WEBPACK FOOTER //
// ./src/pages/validation/vis.models.ts